import { z } from 'zod';
import { ProductListItemSchema } from './catalog.js';
import { IdSchema, nullableText, requiredText } from './common.js';
/**
 * Garaj — marka → model → yil, select orqali. VIN YO'Q, moslik jadvali YO'Q.
 *
 * Moslik `Product.searchTags` orqali aniqlanadi va bu EHTIMOLLIK, kafolat emas.
 * Shuning uchun matnda hech qachon "mos keladi" deyilmaydi — "Tracker 2023 uchun"
 * deyiladi (docs/02-MAHSULOT.md, avtopart-ui skill).
 */
export const VehicleMakeResponseSchema = z.object({
    id: IdSchema,
    name: z.string(),
    logoUrl: nullableText(255),
    sort: z.number().int(),
});
export const VehicleModelResponseSchema = z.object({
    id: IdSchema,
    makeId: IdSchema,
    makeName: z.string(),
    name: z.string(),
    yearFrom: z.number().int(),
    yearTo: z.number().int(),
    sort: z.number().int(),
});
export const UserVehicleResponseSchema = z.object({
    id: IdSchema,
    modelId: IdSchema,
    makeName: z.string(),
    modelName: z.string(),
    year: z.number().int(),
    isActive: z.boolean(),
});
/** Yil oralig'i modelning `yearFrom`..`yearTo` ichida ekanini server tekshiradi. */
export const AddUserVehicleSchema = z
    .object({
    modelId: IdSchema,
    year: z.number().int().min(1980).max(2100),
    isActive: z.boolean().default(true),
})
    .strict();
export const CreateVehicleModelSchema = z
    .object({
    makeId: IdSchema,
    name: requiredText(60),
    yearFrom: z.number().int().min(1980).max(2100),
    yearTo: z.number().int().min(1980).max(2100),
    /** Qidiruv yozilishlari: "treker, трекер, tacker". */
    aliases: z.string().trim().max(500).optional(),
    sort: z.number().int().min(0).max(9999).optional(),
})
    .strict()
    .refine((v) => v.yearFrom <= v.yearTo, {
    message: "Boshlanish yili tugash yilidan katta bo'lishi mumkin emas",
    path: ['yearTo'],
});
/* ========================= admin: avtomobillar ========================= */
/**
 * Admin uchun model javobi.
 *
 * Mijoz javobida `aliases` va `isActive` YO'Q: birinchisi qidiruvni
 * sozlash maydoni, ikkinchisi esa mijozga ko'rinmaydigan yozuvlar
 * uchun — ular ro'yxatga umuman tushmaydi.
 */
export const AdminVehicleModelResponseSchema = VehicleModelResponseSchema.extend({
    aliases: nullableText(2000),
    isActive: z.boolean(),
});
export const CreateVehicleMakeSchema = z
    .object({
    name: requiredText(60),
    logoUrl: z.string().trim().max(255).optional(),
    sort: z.number().int().min(0).max(9999).optional(),
})
    .strict();
export const UpdateVehicleMakeSchema = CreateVehicleMakeSchema.partial()
    .extend({ isActive: z.boolean().optional() })
    .strict();
export const UpdateVehicleModelSchema = z
    .object({
    name: requiredText(60).optional(),
    yearFrom: z.number().int().min(1950).max(2100).optional(),
    yearTo: z.number().int().min(1950).max(2100).optional(),
    aliases: z.string().trim().max(2000).nullable().optional(),
    sort: z.number().int().min(0).max(9999).optional(),
    isActive: z.boolean().optional(),
})
    .strict();
/* ============================ tavsiya bloki ============================ */
/**
 * Garajga asoslangan tavsiya.
 *
 * `items` BO'SH bo'lsa blok butunlay YASHIRILADI. Yarim bo'sh
 * "sizning mashinangiz uchun" ro'yxati eng yomon variant: u
 * "bizda sizning mashinangizga hech narsa yo'q" degan ma'no beradi
 * va mijozni haydaydi.
 */
export const RecommendationResponseSchema = z.object({
    /** Faol mashina — yo'q bo'lsa `null` va blok ko'rsatilmaydi. */
    vehicleLabel: z.string().nullable(),
    items: z.array(ProductListItemSchema),
});
/**
 * Blok chiqishi uchun kerakli ENG KAM tovar soni.
 *
 * Bu qoida STATIK qaror emas, ISHLASH VAQTIDAGI chegara: katalog
 * kichik bo'lganda blok o'zi yashirinadi va katalog o'sganda o'zi
 * paydo bo'ladi. Boshqacha qilib "hozir qamrov yetarlimi" degan
 * savolga bir marta javob berish kerak bo'lardi va u eskirardi.
 */
export const RECOMMENDATION_MIN_ITEMS = 4;
//# sourceMappingURL=garage.js.map